
import axios from 'axios';
import { Toast } from 'vant';
/**
 * Created by qizp on 2019/3/26.
 */
// const BASE_URL = process.env.NODE_ENV === 'development' ? 'https://www.tuoche.zkzwpz.com.cn:443/jhy_app':'https://www.juhaoyun.com.cn:443/jhy_app';
// const BASE_URL = process.env.NODE_ENV === 'development' ? 'https://test.juhaoyun.com.cn:443/jhy_app' :'https://test.juhaoyun.com.cn:443/jhy_app';
const BASE_URL = `${process.env.VUE_APP_API_URL}/jhy_app`;
// const BASE_URL = "/api"


// 新请求，方便后续扩展
const config = {
  baseURL: BASE_URL || '', // 接口统一域名
  timeout: 60 * 1000, // 请求超时时间设置
  // crossDomain: true, // 跨域
}
//1 创建请求实例
const _axios = axios.create(config)
// ------------------- 一、请求拦截器
//2 请求拦截器
_axios.interceptors.request.use((reqConfig) => {
  // 大小写容错
  reqConfig.method = reqConfig.method.toLowerCase()
  // 参数容错
  if (reqConfig.method === 'get') {
    if (!reqConfig.params) {
      // 防止字段用错
      reqConfig.params = reqConfig.data || {}
    }
  } else if (reqConfig.method === 'post') {
    if (!reqConfig.data) {
      // 防止字段用错
      reqConfig.data = reqConfig.params || {}
    }

    // 检测是否包含文件类型, 若包含则进行 formData 封装
    let hasFile = false
    Object.keys(reqConfig.data).forEach(key => {
      if (typeof reqConfig.data[key] === 'object') {
        const item = reqConfig.data[key]
        if (item instanceof FileList || item instanceof File || item instanceof Blob) {
          hasFile = true
        }
      }
    })
    console.log("hasFile", hasFile);
    // 判断已经是FormData对象不进行其他处理
    if (reqConfig.data instanceof FormData) {
      return reqConfig
    }

    // 检测到存在文件使用 FormData 提交数据
    if (hasFile) {
      const formData = new FormData()
      Object.keys(reqConfig.data).forEach(key => {
        formData.append(key, reqConfig.data[key])
      })
      reqConfig.data = formData
      console.log('reqConfig.data', reqConfig.data);

    } else {
      // data里面没有body，加一层body
      if (reqConfig.data&&!reqConfig.data.body) {
        const body = reqConfig.data;
        reqConfig.data  ={
          body: body,
        }
      }
      reqConfig.data.head = {
        usercode: localStorage.getItem('usercode'),
        areacode: localStorage.getItem('addressCode') || '',
        areaname: localStorage.getItem('addressName') || '',
        userid: localStorage.getItem('userid'),
        phone: localStorage.getItem('phone'),
        usertype: localStorage.getItem('usertype'),
      }
    }
  } else {
    // TODO: 其他类型请求数据格式处理
    /* eslint-disable-next-line */
    console.warn(`其他请求类型: ${reqConfig.method}, 暂无自动处理`)
  }

  return reqConfig
},
  error => Promise.reject(error),
)
_axios.interceptors.response.use(
  response => {
    console.log(`本次完整返回res=`, response)
    if (response.data.errcode != '0') {
      Toast({
        message: response.data.message||'server_error',
        position: 'bottom',
        duration: 2000
      })
    }
    return response.data
  },
  error => {
    Toast({
      message: 'server_error',
      position: 'bottom',
      duration: 2000
    })

    return Promise.reject(error)
  }
)
// 导出常用函数
const axiosjs = (datas) => {
  console.log('datas,BASE_URL', datas, BASE_URL)
  return post(datas.url, datas.data, datas.params)
}
export const axiosImage = (datas) => {
  return post(datas.url, datas.data, datas.params)
}
export { axiosjs }
/**
 * @param {string} url
 * @param {object} data
 * @param {object} params
 */
export function post(url, data = {}, params = {}) {
  return _axios({
    method: 'post',
    url,
    data,
    params
  })
}


//////////////////
// WEBPACK FOOTER
// ./static/axios.js
// module id = 81r7
// module chunks = 39